import type { LucideIcon } from 'lucide-react';
import { Archive, Cable, MessageSquare, Workflow } from 'lucide-react';

export const INTEGRATIONS_SECTION = {
  agentConnectors: 'agent-connectors',
  channels: 'channels',
  crms: 'crms',
  fileStorage: 'file-storage',
} as const;

type IntegrationsNavSection = {
  dataCy: string;
  icon: LucideIcon;
  id: (typeof INTEGRATIONS_SECTION)[keyof typeof INTEGRATIONS_SECTION];
  label: string;
  searchTerms: string[];
};

export const INTEGRATIONS_NAV_SECTIONS: IntegrationsNavSection[] = [
  {
    dataCy: 'admin-integrations-channels',
    icon: MessageSquare,
    id: INTEGRATIONS_SECTION.channels,
    label: 'Channels',
    searchTerms: ['Slack', 'Teams', 'Microsoft Teams', 'Channels'],
  },
  {
    dataCy: 'admin-integrations-file-storage',
    icon: Archive,
    id: INTEGRATIONS_SECTION.fileStorage,
    label: 'File Storage',
    searchTerms: ['File Storage'],
  },
  {
    dataCy: 'admin-integrations-crms',
    icon: Workflow,
    id: INTEGRATIONS_SECTION.crms,
    label: 'CRMs',
    searchTerms: ['CRMs'],
  },
  {
    dataCy: 'admin-integrations-connectors',
    icon: Cable,
    id: INTEGRATIONS_SECTION.agentConnectors,
    label: 'Connectors',
    searchTerms: ['Connectors'],
  },
];
